import { HomeLSB } from "./home-lsb";
import { LegacyLeftSidebar, type LeftSidebarProps } from "./legacy-sidebar";

// TODO(홈 개편): 개편 완료 후 스위치와 activeMenu prop 을 지우고 HomeLSB 만 남긴다. 되돌릴 땐 false.
const USE_NEW_LSB = true;

export const LeftSidebar = ({ activeMenu }: LeftSidebarProps) =>
  USE_NEW_LSB ? <HomeLSB /> : <LegacyLeftSidebar activeMenu={activeMenu} />;
